import PropTypes from 'prop-types';

import { useIntl } from 'react-intl';

import { BasicButton } from 'components/common/buttons';
import { Grid } from '@material-ui/core';

const ResetCredentialFooter = ({ empty, isDisabled, handleSubmit, handleBack }) => {
  const { formatMessage } = useIntl();

  return (
    <Grid container>
      <Grid container justify="flex-end">
        {isDisabled && (
          <BasicButton
            title={formatMessage({ id: 'selfUnlock.modal.backButton' })}
            className="transparent-bb db ph4 back-button-spacing"
            onClick={handleBack}
          />
        )}

        <BasicButton
          disabled={empty}
          title={formatMessage({ id: 'selfUnlock.modal.footerButton' })}
          className="db ph4"
          onClick={handleSubmit}
        />
      </Grid>
    </Grid>
  );
};

ResetCredentialFooter.defaultProps = {
  isDisabled: false,
};

ResetCredentialFooter.propTypes = {
  empty: PropTypes.bool.isRequired,
  isDisabled: PropTypes.bool,
  handleSubmit: PropTypes.func.isRequired,
  handleBack: PropTypes.func.isRequired,
};

export default ResetCredentialFooter;
